var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"logoutBtn mdi mdi-power",attrs:{"title":_vm.$t('footeractions.logout')},on:{"click":_vm.logout}})
}
var staticRenderFns = []

export { render, staticRenderFns }